import { useEffect, useState } from 'react';
import { getGuidebooks, renderDate } from '../../utils/utils';
import Loading from '../Loading';
import { Link } from 'react-router-dom';

let FeaturedGuidebooks = () => {
  let [featuredGuidebooks, setFeaturedGuidebooks] = useState([]);
  let [loading, setLoading] = useState(false);
  useEffect(() => {
    async function fetch() {
      setLoading(true);
      let featuredGuidebooks = await getGuidebooks();
      setFeaturedGuidebooks(featuredGuidebooks);

      setLoading(false);
    }
    fetch();
  }, []);

  return (
    <div className="guidebooks">
      {/* <h2> Featured Guidebooks </h2> */}
      {loading && <Loading />}
      <div className="grid grid-cols-3 gap-6">
        {featuredGuidebooks.length > 0 &&
          featuredGuidebooks.map((guidebook) => (
            <GuidebookCard guidebook={guidebook} key={guidebook.id} />
          ))}
      </div>
    </div>
  );
};

let GuidebookCard = ({ guidebook }) => {
  if (!guidebook.acf.guidebook_published) return null;
  return (
    <Link
      key={guidebook.id}
      reloadDocument
      className="cursor-pointer lg:col-span-1 col-span-3"
      to={`/library/guidebooks/${guidebook.slug}`}
    >
      <div
        key={guidebook.id}
        className="guidebook-card h-full  bg-[var(--gray)] px-4 py-6 shadow-sm mt-4 border-b-4 border-[var(--primary)]"
      >
        <h4>{decodeHtml(guidebook.name)}</h4>
        <time
          dateTime={guidebook.last_modified}
          className="text-sm text-gray-500"
        >
          Updated: {renderDate(guidebook.last_modified)}
        </time>
        <p>{guidebook.description}</p>
      </div>
    </Link>
  );
};

function decodeHtml(html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

export { GuidebookCard, decodeHtml };
export default FeaturedGuidebooks;
